import { registerExtension } from "@core/components/PipelineComponents/ExtensionProvider";

const ReportBuilderInvoiceOptionAbove = () => {
  return <option value='[{"Key":"Type","Value":"Invoices"},{"Key":"Location","Value":"Above"}]'>Invoices - Above</option>;
};

const ReportBuilderInvoiceOptionBelow = () => {
  return <option value='[{"Key":"Type","Value":"Invoices"},{"Key":"Location","Value":"Below"}]'>Invoices - Below</option>;
}

registerExtension('reportbuilder.location.select', ReportBuilderInvoiceOptionAbove, "ReportBuilderInvoiceOptionAbove");
registerExtension('reportbuilder.location.select', ReportBuilderInvoiceOptionBelow, "ReportBuilderInvoiceOptionBelow");
